module.exports = __webpack_public_path__ + "static/img/wuneirong.6db0028.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wuneirong.jpg
// module id = T/fs
// module chunks = 31